import React, {useEffect, useState} from 'react';
import {Instrument} from '../gen/api';
import InstrumentService from "../services/instrument.service";
import InstrumentForm from "../components/InstrumentForm/InstrumentForm";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch} from "../store";
import {setErrorMessage, setSuccessMessage} from "../store/reducers/message";
import {addInstrument} from "../store/reducers/instruments";
import {selectInstrumentById} from "../store/selectors";


function NewInstrument() {
  const {instrumentId} = useParams();
  const originalInstrument = useSelector(selectInstrumentById(instrumentId));
  const [copiedInstrument, setCopiedInstrument] = useState<Instrument>();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (originalInstrument) {
      // Reset dates and name (must be unique) when instrument is copied. Ids will automatically be overridden (newly generated) and uploaded files will be cloned by the backend
      setCopiedInstrument({
        ...originalInstrument,
        name: "",
        createTimestamp: undefined,
        lastUpdateTimestamp: undefined
      })
    }
  }, [originalInstrument]);

  const submitInstrument = (newInstrument: Instrument) => {
    InstrumentService.createInstrument(newInstrument).then(response => {
      if (response) {
        dispatch(addInstrument(response));
        dispatch(setSuccessMessage("Das Instrument wurde angelegt."));
        navigate(`/show/${response.id}`);
      }
    }).catch(_ => {
      dispatch(setErrorMessage("Das Instrument konnte nicht angelegt werden. Bitte versuchen Sie es später erneut."));
    });
  }

  const navigateToSearch = () => navigate("/search");
  const navigateToView = () => navigate(`/show/${instrumentId}`);

  return (
      <InstrumentForm handleSubmitInstrument={submitInstrument} instrument={copiedInstrument}
                      handleAbort={instrumentId ? navigateToView : navigateToSearch}/>
  );
}

export default NewInstrument;